<template>
    <div class="view-details" :class="{ open: chart.viewDetails.open }">
        <div class="view-details-header">
            <h4>{{ details.brand_name }}</h4>
            <div class="view-details-header-static">
                <span>{{ details.company_name }}</span>
            </div>
            <img src="../../../assets/images/close-big.svg"  class="view-details--close"
                 @click="closeViewDetails" alt="Close" />
        </div>
        <VueCustomScrollbar class="view-details-content" v-if="Object.keys(details).length > 0">
            <div class="view-details-scroll-content">
                <div class="view-details-section">
                    <h4 class="view-details-section-title">Markets</h4>
                    <div class="view-details-section-content">
                        <template v-if="details.markets.length === 0">
                            <div class="view-details-market none">None</div>
                        </template>
                        <template v-else>
                            <div class="view-details-market" v-for="market in markets" :key="market.id">
                                <div style="display: flex; flex-direction: column;">
                                <div>
                                <span class="view-details-company"
                                    v-if="showCompanyName(market.brand_name.brand_name)"
                                >
                                    {{ market.brand_name.brand_name }}
                                </span>
                                <span class="view-details-market-name">{{ market.market.market }}</span>
                                <span class="view-details-market-since">since {{ market.since_date }}</span>
                                </div>
                               <div  v-if="details.company_name !==market.company.name " class="view-details-market-company"><span >&nbsp;Company: {{ market.company.name }}</span></div>
                                </div>
                            </div>
                            <a href="#" class="show-more-button"
                                v-if="details.markets.length > 3"
                                @click="toggleShowAll($event, 'markets')"
                            >
                                <span>Show {{ showAll.markets ? 'less' : 'more' }} markets</span>
                                <i :class="`fa fa-angle-${showAll.markets ? 'up' : 'down'}`"></i>
                            </a>
                        </template>
                    </div>
                </div>
                <div class="view-details-section">
                    <h4 class="view-details-section-title">Indications</h4>
                    <div class="view-details-section-content">
                        <template v-if="details.drug_indications.length === 0">
                            <div class="view-details-indications view-details-list">
                                <div class="view-details-indication view-details-list-item none">None</div>
                            </div>
                        </template>
                        <template v-else>
                            <ul class="view-details-indications view-details-list">
                                <li class="view-details-indication view-details-list-item"
                                    v-for="indication in indications"
                                    :key="indication.id"
                                >
                                    <p class="view-details-indication-name">
                                        <span class="view-details-company"
                                            v-if="showCompanyName(indication.brand_name.brand_name)"
                                        >
                                            {{ indication.brand_name.brand_name }}
                                        </span>
                                        {{ indication.indication.name }}
                                    </p>
                                    <p class="view-details-indication-date">
                                        <span>Date of approval: </span>
                                        <span>{{ indication.approval_date ? indication.approval_date : 'N/A' }}</span>
                                    </p>
                                    <p class="view-details-indication-market">
                                        <span>Market: </span>
                                        <span>{{ indication.original_market ? indication.original_market.market : 'N/A' }}</span>
                                    </p>
                                    <p class="view-details-indication-market" v-if="details.company_name !==indication.company.name ">

                                        <span>COMPANY: </span>
                                        <span>{{ indication.company.name }}</span>
                                    </p>
                                </li>
                            </ul>
                            <a href="#" class="show-more-button"
                                v-if="details.drug_indications.length > 3"
                                @click="toggleShowAll($event, 'indications')"
                            >
                                <span>Show {{ showAll.indications ? 'less' : 'more' }} indications</span>
                                <i :class="`fa fa-angle-${showAll.indications ? 'up' : 'down'}`"></i>
                            </a>
                        </template>
                    </div>
                </div>
                <div class="view-details-section">
                    <h4 class="view-details-section-title">Classes</h4>
                    <div class="view-details-section-content">
                        <template v-if="details.drug.classes.length === 0">
                            <div class="view-details-classes view-details-list">
                                <div class="view-details-class view-details-list-item none">None</div>
                            </div>
                        </template>
                        <template v-else>
                            <ul class="view-details-classes view-details-list">
                                <li class="view-details-class view-details-list-item"
                                    v-for="classObject in classes"
                                    :key="classObject.id"
                                >
                                    <span>
                                        <span>{{ classObject.name }}</span>
                                        <a  
                                            v-if="form.classed_fic_bic_data[classObject.id] 
                                                && (details.classed_fic_bic_data[classObject.id].fic_brand_id || details.classed_fic_bic_data[classObject.id].bic_brand_id)"

                                            href="#" class="btn-link btn-primary ml-2"
                                            @click="openResetClassDataModal(classObject.id)">
                                            Reset
                                        </a>
                                    </span>
                                    <div v-if="form.classed_fic_bic_data[classObject.id]">
                                        <!-- FIC -->
                                        <template v-if="details.group_revenue == 1" >
                                            <v-checkbox
                                                    :value="form.classed_fic_bic_data[classObject.id].fic_brand_id"
                                                    :input-value="form.classed_fic_bic_data[classObject.id].fic_brand_id"
                                                    :disabled="details.classed_fic_bic_data[classObject.id].fic_brand_id != null"
                                                    color="#5db599"
                                                    @click="changeFic(classObject.id, form.classed_fic_bic_data[classObject.id].fic_brand_id != null)"
                                                    label="First In Class (FIC)"
                                                >
                                            </v-checkbox>
                                            <div 
                                                class="d-flex justify-space-between"
                                                v-if="form.classed_fic_bic_data[classObject.id].fic_brand_id" >
                                                <span
                                                    v-if="form.classed_fic_bic_data[classObject.id].fic_brand_id == details.classed_fic_bic_data[classObject.id].fic_brand_id"
                                                >
                                                    {{ details.classed_fic_bic_data[classObject.id].fic_from }} - ?
                                                </span>
                                                    <div class="brand-view-wrapper">
                                                        <a href="#" class="btn-link btn-primary"
                                                            @click="changeFic(classObject.id, details.classed_fic_bic_data[classObject.id].fic_brand_id == null)"
                                                            >
                                                            Change
                                                        </a>

                                                        <span 
                                                            class="view-brand" 
                                                        >
                                                            {{ brands.find((e) => e.id == form.classed_fic_bic_data[classObject.id].fic_brand_id).brand_name }}
                                                        </span>
                                                    
                                                    </div>
                                            </div>
                                            <div class="history-wrapper" v-if="details.classed_fic_bic_data[classObject.id].fic_history.length > 0">
                                                <span class="header">
                                                    <svg class="ico" width="24px" height="24px">
                                                        <use xlink:href="#ico-history"></use>
                                                    </svg>
                                                    <span>History</span>
                                                </span>
                                                <div
                                                    :key="data.id"
                                                    v-for="data in details.classed_fic_bic_data[classObject.id].fic_history"
                                                    class="item"
                                                >
                                                    <span>
                                                        {{ data.fic_from + ' - '+ data.fic_to }}
                                                    </span>
                                                    <div class="brand-view-wrapper">
                                                        <span class="view-brand" >
                                                            {{ data.brand_name  }}
                                                        </span>
                                                    </div>
                                                    
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="history-wrapper"  v-if="details.classed_fic_bic_data[classObject.id]['fic_history'].length>0">
                                                <div class="header">
                                                    <svg class="ico" width="24px" height="24px">
                                                        <use xlink:href="#ico-history"></use>
                                                    </svg>
                                                    <span>First in Class (FIC)</span>
                                                </div>
                                                <div>
                                                    {{ details.classed_fic_bic_data[classObject.id]['fic_history'][0]['fic_from'] + ' - ' +  details.classed_fic_bic_data[classObject.id]['fic_history'][0]['fic_to'] }}
                                                </div>
                                            </div>
                                            <v-checkbox
                                                    v-else
                                                    v-model="form.classed_fic_bic_data[classObject.id].fic_brand_id"
                                                    :false-value="null"
                                                    :true-value="details.id"
                                                    :disabled="details.classed_fic_bic_data[classObject.id].fic_brand_id != null"
                                                    @change="updateHasFormChanged"
                                                    color="#5db599"
                                                    label="First In Class (FIC)"
                                            />
                                             <span
                                                v-if="form.classed_fic_bic_data[classObject.id].fic_brand_id != null &&  form.classed_fic_bic_data[classObject.id].fic_brand_id == details.classed_fic_bic_data[classObject.id].fic_brand_id"
                                            >
                                                {{ details.classed_fic_bic_data[classObject.id].fic_from }} - ?
                                            </span>
                                        </template>
                                        
                                        <!-- BIC -->
                                        <template v-if="details.group_revenue == 1" >
                                            <v-checkbox
                                                    :value="form.classed_fic_bic_data[classObject.id].bic_brand_id"
                                                    :input-value="form.classed_fic_bic_data[classObject.id].bic_brand_id"
                                                    :disabled="details.classed_fic_bic_data[classObject.id].bic_brand_id != null"
                                                    @click="changeBic(classObject.id, form.classed_fic_bic_data[classObject.id].bic_brand_id != null)"
                                                    color="#5db599"
                                                    label="Best In Class (BIC)"
                                                >
                                            </v-checkbox>
                                            <div 
                                                class="d-flex justify-space-between"
                                                v-if="form.classed_fic_bic_data[classObject.id].bic_brand_id" >
                                                <span
                                                    v-if="form.classed_fic_bic_data[classObject.id].bic_brand_id == details.classed_fic_bic_data[classObject.id].bic_brand_id"
                                                >
                                                    {{ details.classed_fic_bic_data[classObject.id].bic_from }} - ?
                                                </span>
                                                <div class="brand-view-wrapper" >
                                                    <a href="#" class="btn-link btn-primary"
                                                        @click="changeBic(classObject.id, details.classed_fic_bic_data[classObject.id].bic_brand_id == null)"
                                                        >
                                                        Change
                                                    </a>
                                                    <span 
                                                        class="view-brand" 
                                                        >
                                                        {{ brands.find((e) => e.id == form.classed_fic_bic_data[classObject.id].bic_brand_id).brand_name }}
                                                    </span>
                                                </div>
                                            </div>
                                            <div class="history-wrapper" v-if="details.classed_fic_bic_data[classObject.id].bic_history.length > 0">
                                                <span class="header">
                                                    <svg class="ico" width="24px" height="24px">
                                                        <use xlink:href="#ico-history"></use>
                                                    </svg>
                                                    <span>History</span>
                                                </span>
                                                <div 
                                                    :key="data.id"
                                                    v-for="data in details.classed_fic_bic_data[classObject.id].bic_history"
                                                    class="item"
                                                >
                                                    <span>
                                                        {{ data.bic_from + ' - '+ data.bic_to }}
                                                    </span>
                                                    <div class="brand-view-wrapper">
                                                        <span class="view-brand" >
                                                            {{ data.brand_name  }}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>
                                        <template v-else>
                                            <div class="history-wrapper" v-if="details.classed_fic_bic_data[classObject.id]['bic_history'].length>0">
                                                <div class="header">
                                                    <svg class="ico" width="24px" height="24px">
                                                        <use xlink:href="#ico-history"></use>
                                                    </svg>
                                                    <span>Best in Class (BIC)</span>
                                                </div>
                                                <div>
                                                    {{ details.classed_fic_bic_data[classObject.id]['bic_history'][0]['bic_from'] + ' - ' +  details.classed_fic_bic_data[classObject.id]['bic_history'][0]['bic_to'] }}
                                                </div>
                                            </div>
                                            <v-checkbox
                                                    v-else
                                                    :false-value="null"
                                                    :true-value="details.id"
                                                    :input-value="form.classed_fic_bic_data[classObject.id].bic_brand_id"
                                                    :disabled="details.classed_fic_bic_data[classObject.id].bic_brand_id != null"
                                                    @click.self="changeBic(classObject.id, form.classed_fic_bic_data[classObject.id].bic_brand_id != null)"
                                                    color="#5db599"
                                                    label="Best In Class (BIC)"
                                            />
                                            <span
                                                v-if="form.classed_fic_bic_data[classObject.id].bic_brand_id != null &&  form.classed_fic_bic_data[classObject.id].bic_brand_id == details.classed_fic_bic_data[classObject.id].bic_brand_id"
                                            >
                                                {{ details.classed_fic_bic_data[classObject.id].bic_from }} - ?
                                            </span>
                                        </template>

                                    </div>
                                </li>
                            </ul>
                            <a :class="{disabled: saving}" v-show="hasFormChanged" href="#" class="btn-link btn-primary my-3"
                                @click="saveFicBicChanges"
                            >
                                <div v-if="saving" class="mr-3">
                                    <i class="fa fa-spinner fa-spin spinner"></i>
                                </div>
                                <span>Save Changes</span>
                            </a> 
                            <a href="#" class="show-more-button"
                                v-if="details.drug.classes.length > 3"
                                @click="toggleShowAll($event, 'classes')"
                            >
                                <span>Show {{ showAll.classes ? 'less' : 'more' }} classes</span>
                                <i :class="`fa fa-angle-${showAll.classes ? 'up' : 'down'}`"></i>
                            </a>
                        </template>
                    </div>
                </div>
                <div class="view-details-section">
                    <h4 class="view-details-section-title">Categories</h4>
                    <div class="view-details-section-content">
                        <template v-if="details.categories.length === 0">
                            <div class="view-details-categories view-details-list">
                                <div class="view-details-category view-details-list-item none">None</div>
                            </div>
                        </template>
                        <template v-else>
                            <ul class="view-details-categories view-details-list">
                                <li class="view-details-category view-details-list-item" style="margin-top: -10px;"
                                    v-for="parent in getParents(categories)"
                                    :key="parent"
                                >   
                                    <div class="category-item">
                                        <img src="../../../assets/images/category.svg" alt="Legend - Show more" />
                                        <span style=" padding-left: 10px;"> {{ parent }} </span>
                                    </div>
                                    <div class="sub-category-icon" v-for="child in getChildCategory(parent,categories)">
                                        <img src="../../../assets/images/category.svg" alt="Legend - Show more" /> 
                                        <span>{{child.name}}</span>
                                        <div class="view-brand-div">
                                            <span class="view-brand" v-for="brand in child.brand_name" v-if="child.brand_name.length > 0">
                                                {{brand.brand_name}}
                                            </span>
                                        </div>
                                    </div>

                                </li>
                            </ul>
                            <a href="#" class="show-more-button"
                                v-if="details.categories.length > 3"
                                @click="toggleShowAll($event, 'categories')"
                            >
                                <span>Show {{ showAll.categories ? 'less' : 'more' }} categories</span>
                                <i :class="`fa fa-angle-${showAll.categories ? 'up' : 'down'}`"></i>
                            </a>
                        </template>
                    </div>
                </div>
                <!--<div class="view-details-section">
                    <h4 class="view-details-section-title">Patents</h4>
                    <div class="view-details-section-content">
                        <template v-if="details.drug.patents.length === 0">
                            <div class="view-details-patents view-details-list">
                                <div class="view-details-patent view-details-list-item none">None</div>
                            </div>
                        </template>
                        <template v-else>
                            <ul class="view-details-patents view-details-list">
                                <li class="view-details-patent view-details-list-item"
                                    v-for="patent in patents"
                                    :key="patent.id"
                                >
                                    <p class="view-details-patent-name">{{ patent.name }}</p>
                                    <p class="view-details-patent-expiry">
                                        <span>Expiry: </span>
                                        <span>{{ patent.expiry_date ? patent.expiry_date : 'N/A' }}</span>
                                    </p>
                                </li>
                            </ul>
                            <a href="#" class="show-more-button"
                                v-if="details.drug.patents.length > 3"
                                @click="toggleShowAll($event, 'patents')"
                            >
                                <span>Show {{ showAll.patents ? 'less' : 'more' }} patents</span>
                                <i :class="`fa fa-angle-${showAll.patents ? 'up' : 'down'}`"></i>
                            </a>
                        </template>
                    </div>
                </div>-->
            </div>
        </VueCustomScrollbar>
        <Portal to="modals" v-if="modifyFicBicModal.open">
            <ModifyFicBic 
                :config="modifyFicBicModal.config"
                @close="handleModifyFicBicModalClose" 
                @cancel="resetModifyFicBicModal" 
                @save="handleModifyFicBicModalSave" 
            />
        </Portal>
        <Portal to="modals" v-if="resetFicBicModal.open">
           <ResetFicBic 
                :config="resetFicBicModal.config"
                @close="handleResetFicBicModalClose" 
                @saved="handleResetFicBicModalSaved" 
            />
        </Portal>
        
        <Portal to="modals" v-if="errorsMessages">
           <AlertModal 
                :title="errorDialogTitle"
                :content="Object.values(errorsMessages).join('\n')"
                @close="handleAlertClosed()"
            />
        </Portal>
        
    </div>
</template>

<script>

import ValidationError from "../../../utils/ValidationError";
import ModifyFicBic from "./ViewDetails/ModifyFicBic";
import ResetFicBic from "./ViewDetails/ResetFicBic";
import AlertModal from "./AlertModalComponent";
import VueCustomScrollbar from 'vue-custom-scrollbar';
import { Portal } from 'portal-vue'

export default {
    components: {
        VueCustomScrollbar,
        Portal,
        ModifyFicBic,
        ResetFicBic,
        AlertModal,
    },
    props: {
        chart: {
            type: Object,
        },
    },
    computed: {
        details() {
            return this.chart.viewDetails.data;
        },
        brands() {
            return this.$store.getters['brand/getAll'];
        },
        markets() {
            return this.details.markets.filter((market, index) => {
                if (!this.showAll.markets) {
                    return index < 3;
                }

                return true;
            });
        },
        indications() {
            return this.details.drug_indications.filter((indication, index) => {
                if (!this.showAll.indications) {
                    return index < 3;
                }

                return true;
            });
        },
        classes() {
            return this.details.drug.classes.filter((classObject, index) => {
                if (!this.showAll.classes) {
                    return index < 3;
                }

                return true;
            });
        },
        categories() {
            return this.details.categories.filter((category, index) => {
                if (!this.showAll.categories) {
                    return index < 3;
                }

                return true;
            });
        },
        patents() {
            return this.details.drug.patents.filter((patent, index) => {
                if (!this.showAll.patents) {
                    return index < 3;
                }

                return true;
            });
        },
        errorDialogTitle(){
            if(this.errorsMessages == null){
                return '';
            }

            if(this.errorsMessages.fic_brand_id && this.errorsMessages.bic_brand_id){
                return 'Set FIC/BIC Error'
            }

            if(this.errorsMessages.fic_brand_id){
                return 'Set FIC Error'
            }

            if(this.errorsMessages.bic_brand_id){
                return 'Set BIC Error'
            }

            return 'Error';
        }
    },
    watch:{
        'chart.viewDetails.open'(newVal){
            this.modifyFicBicModal = {
                open: false,
                config: null,
            };
            if(newVal){
                this.form.classed_fic_bic_data={};
                this.errorsMessages= null;
                this.hasFormChanged=false;
                const config = {};
                config.initialBrand = null;
                config.classId = null;
                config.allowClear = false;

                Object.keys(this.details.classed_fic_bic_data).forEach((key)=>{
                    this.form.classed_fic_bic_data[key] = {
                        fic_brand_id: this.details.classed_fic_bic_data[key].fic_brand_id,
                        bic_brand_id: this.details.classed_fic_bic_data[key].bic_brand_id,
                        bic_from: this.details.classed_fic_bic_data[key].bic_from,
                        is_bic_from_launch: this.details.classed_fic_bic_data[key].is_bic_from_launch,
                    };
                });

                config.brands = this.details.fic_bic_brands.map((e)=>{
                    return {
                        id: parseInt(e.id),
                        market_launch_date: e.market_launch_date,
                        label: e.brand_name,
                    };
                });
                this.modifyFicBicModal = { ...this.modifyFicBicModal, config };

            }
        },
    },
    data() {
        return {
            showAll: {
                markets: false,
                indications: false,
                classes: false,
                categories: false,
                patents: false,
            },
            hasFormChanged: false,
            saving: false,
            errorsMessages: null,
            updatingClassId: null,
            form: {
                classed_fic_bic_data:{},
            },
            modifyFicBicModal:{
                config: null,
                open : false,
            },
            resetFicBicModal:{
                config: null,
                open : false,
            },
        };
    },
    methods: {
        closeViewDetails() {
            this.$store.commit('chart/toggleViewDetails', { isOpen: false });
        },
        getParents(categories){
            let parents =[];
            categories.forEach((cat)=>{
                if(cat.parent &&  parents.indexOf(cat.parent.name) < 0){
                    parents.push(cat.parent.name);
                   
                }
            })
            return parents;
        },
         getChildCategory(parentName, categories){
            let childs =[];
            categories.forEach((cat)=>{
            
                if(cat.parent &&  cat.parent.name === parentName){
                    childs.push(cat);
                   
                }
            })
            return childs;
        }
        ,
        toggleShowAll(event, entity) {
            event.preventDefault();
            this.showAll[entity] = !this.showAll[entity];
        },
        showCompanyName(brandName) {
            return brandName !== this.details.brand_name.trim().split(' (')[0];
        },
        isFic(brandId, classId){
            return brandId != null &&  this.details.classed_fic_bic_data[classId].fic_brand_id == brandId;
        },        
        isBic(brandId, classId){
            return  brandId != null &&   this.details.classed_fic_bic_data[classId].bic_brand_id == brandId;
        },
        updateHasFormChanged(){
            this.hasFormChanged =  Object.entries(this.form.classed_fic_bic_data)
                .findIndex(([key, value])=>{
                    return  this.details.classed_fic_bic_data[key].fic_brand_id !== value.fic_brand_id  ||  this.details.classed_fic_bic_data[key].bic_brand_id !== value.bic_brand_id 
                }) >= 0;
        },
        changeBic(classId, allowClear = false){
            if(!this.details.group_revenue
                && this.form.classed_fic_bic_data[classId].bic_brand_id != null
            ){
                this.form.classed_fic_bic_data[classId].bic_brand_id = null;
                this.updateHasFormChanged();
                return;
            }

            let initialDate = this.form.classed_fic_bic_data[classId].bic_from;

            this.modifyFicBicModal = {
                open: true,
                config:{
                    ...this.modifyFicBicModal.config,
                    actionType : 'changeBic',
                    title : 'Modify BIC Brand',
                    initialSelectedBrand: this.form.classed_fic_bic_data[classId].bic_brand_id,
                    initialDate: initialDate,
                    initialUseLaunchDate: this.form.classed_fic_bic_data[classId].is_bic_from_launch,
                    canSetCustomDate: true,
                    classId: classId,
                    allowClear: allowClear,
                }
            }
        },
        changeFic(classId, allowClear = false){
            this.modifyFicBicModal = {
                open: true,
                config:{
                    ...this.modifyFicBicModal.config,
                    actionType : 'changeFic',
                    title : 'Modify FIC Brand',
                    initialSelectedBrand: this.form.classed_fic_bic_data[classId].fic_brand_id,
                    canSetCustomDate: false,
                    classId: classId,
                    allowClear: allowClear,
                }
            }
        },
        handleModifyFicBicModalClose(){
            this.modifyFicBicModal = {
                ...this.modifyFicBicModal,
                open: false,
            }
        }, 
        resetModifyFicBicModal(){
            this.modifyFicBicModal = {
                open: false,
                config:{
                    ...this.modifyFicBicModal.config,
                    actionType : null,
                    title : null,
                    initialBrand: null,
                    classId: null,
                    allowClear: false,
                    canSetCustomDate: false,
                }
            }
            this.updateHasFormChanged();
        },
        handleModifyFicBicModalSave(selectedBrandId, selectedDate){
            const newValue = selectedBrandId && selectedBrandId > 0 ? selectedBrandId : null;
            switch (this.modifyFicBicModal.config.actionType) {
                case 'changeFic':
                    this.form.classed_fic_bic_data[ this.modifyFicBicModal.config.classId]={
                        ...this.form.classed_fic_bic_data[this.modifyFicBicModal.config.classId],
                        fic_brand_id: newValue,
                    }
                    break;

                case 'changeBic':
                    this.form.classed_fic_bic_data[ this.modifyFicBicModal.config.classId]={
                        ...this.form.classed_fic_bic_data[this.modifyFicBicModal.config.classId],
                        bic_brand_id: newValue,
                        bic_from: selectedDate,
                        is_bic_from_launch: selectedDate == null,
                    }
                    break;
            }
            this.resetModifyFicBicModal();
        },
       async saveFicBicChanges(){
            const requiredChanges = Object.entries(this.form.classed_fic_bic_data)
                .filter(([key, {bic_brand_id, fic_brand_id}])=> !Object.values({ bic_brand_id, fic_brand_id }).every((v)=> v == null)  )
                .map(([key, value])=>{
                    return {
                        id: key,
                        ...value,
                    }
                  
                });

            try {
                this.saving = true;
                this.errorsMessages = null;
                for (let index = 0; index < requiredChanges.length; index++) {
                    const newChange = requiredChanges[index];
                    this.updatingClassId = parseInt(newChange.id);
                    const isUpdated = await this.$store.dispatch("class/updateFicBic", newChange);
                } 

                this.closeViewDetails();

                this.updatingClassId = null;

                // hide isolate
                this.chart.drawingService.lineClickEvent();

                this.$store.dispatch("chart/reloadChart");
                
            } catch (error) {
                if (error instanceof ValidationError) {
                    this.errorsMessages = error.errors;
                } else {
                    console.error(error);
                    this.closeViewDetails();
                }
            } finally {
                this.saving = false;
            }
        },
        openResetClassDataModal(classId){
            const className = this.classes.find((e)=>e.id == classId).name;

            this.resetFicBicModal ={
                open: true,
                config:{
                    classId,
                    className, 
                },
            };
        },
        handleResetFicBicModalSaved(){
            this.closeViewDetails();

            // hide isolate
            this.chart.drawingService.lineClickEvent();

            this.$store.dispatch("chart/reloadChart");

        },
        handleResetFicBicModalClose(){
            this.resetFicBicModal ={
                open: false,
                config: null,
            };
        },
        handleAlertClosed(){
            if(!this.errorsMessages){
                return;
            }

            // reset the form to initial state
            if(this.errorsMessages.fic_brand_id){
                this.form
                    .classed_fic_bic_data[this.updatingClassId]
                    .fic_brand_id = this.details.classed_fic_bic_data[this.updatingClassId].fic_brand_id;
            }

            if(this.errorsMessages.bic_brand_id){
                this.form
                    .classed_fic_bic_data[this.updatingClassId]
                    .bic_brand_id = this.details.classed_fic_bic_data[this.updatingClassId].bic_brand_id;
            }
            this.form = {...this.form};
            this.updateHasFormChanged();
            this.errorsMessages = null;
        }
    },
};

</script>

<style lang="scss">
    @import '../../../style/Charts/ViewChart/ViewDetailsComponent.scss';
</style>
